module.exports = __webpack_public_path__ + "img/error.4fe10c0c.svg";